import { render, staticRenderFns } from "./MedicalProfile.vue?vue&type=template&id=5d8cee47&"
import script from "./MedicalProfile.vue?vue&type=script&lang=js&"
export * from "./MedicalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports